// extracted by mini-css-extract-plugin
module.exports = {"popover__overlay":"popover__overlay__GncCX","popover__overlay--visible":"popover__overlay--visible__EEIR3","popover__container":"popover__container__KVz8S"};